import { TaxServiceName } from "~/api/graphql/schema.generated";

/*
 * Recurring fees (SMT-1366). Mirrors RECURRING_FEE_TAX_SERVICES in
 * kontax-backend. They are set in the "Wiederkehrende Gebühr" block and
 * generated by a job, never recorded under "+ Leistung erfassen".
 */
export const RECURRING_FEE_TAX_SERVICES = [
  TaxServiceName.RECURRING_TAX_SERVICE,
  TaxServiceName.RECURRING_TAX_SERVICE_COMPACT,
  TaxServiceName.RECURRING_BOOKKEEPING_SERVICE,
  TaxServiceName.RECURRING_OTHER_ADVANCE,
  TaxServiceName.RECURRING_OTHER_BOOKKEEPING,
  TaxServiceName.RECURRING_OTHER_FLAT_RATE,
];

// The "Sonstige" kinds: the operator types the name, the STBVV title is picked.
export const OTHER_RECURRING_FEE_TAX_SERVICES = [
  TaxServiceName.RECURRING_OTHER_ADVANCE,
  TaxServiceName.RECURRING_OTHER_BOOKKEEPING,
  TaxServiceName.RECURRING_OTHER_FLAT_RATE,
];

// Offered in the Backoffice. 0 (one-off) exists in the model but is not offered.
export const RECURRING_FEE_RHYTHMS_IN_MONTHS = [1, 3, 6, 12];

// Net suggestions when the fee is set; the stored amount is what bills.
export const RECURRING_FEE_DEFAULT_AMOUNTS_IN_EUROS: Partial<
  Record<TaxServiceName, number>
> = {
  [TaxServiceName.RECURRING_TAX_SERVICE]: 179,
  [TaxServiceName.RECURRING_TAX_SERVICE_COMPACT]: 129,
  [TaxServiceName.RECURRING_BOOKKEEPING_SERVICE]: 79,
};
